/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import VirtualKeyboardHidden from './virtual-keyboard-hidden';

/**
 * Továrna na informace o skryté virtuální klávesnici.
 */
export default class VirtualKeyboardHiddenFactory {
  /**
   * @returns {VirtualKeyboardHidden}
   */
  create() {
    return new VirtualKeyboardHidden();
  }
}
